<template>
  <fb-list-body :pager="pager" :showSearchForm="true" :showBtnGroup="true"
                @handlePagerSizeChange="handlePagerSizeChange" @handlePagerIndexChange="handlePagerIndexChange">

    <template slot="btn-group">
      <el-button icon="el-icon-plus" @click="$router.push({path: '/user-evaluation-add', query: $route.query})">{{$t('lang.新增')}}</el-button>
      <el-button icon="el-icon-delete" @click.native="handleBatchDelete">{{$t('lang.删除')}}</el-button>
    </template>

    <template slot="search-form">
      <el-form-item class="search-form-item" :label="$t('lang.用户编号')">
        <el-input v-model="searchForm.userNumber" clearable></el-input>
      </el-form-item>

      <el-form-item class="search-form-item" :label="$t('lang.评价')">
        <el-select :placeholder="$t('lang.全部')" v-model="searchForm.score" clearable>
          <el-option :label="$t('lang.全部')" value=""></el-option>
          <el-option :label="$t('lang.一星')" value="1"></el-option>
          <el-option :label="$t('lang.二星')" value="2"></el-option>
          <el-option :label="$t('lang.三星')" value="3"></el-option>
          <el-option :label="$t('lang.四星')" value="4"></el-option>
          <el-option :label="$t('lang.五星')" value="5"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="search-form-item" :label="$t('lang.评价时间')">
        <el-date-picker
            v-model="time"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="~"
            :start-placeholder="$t('lang.开始日期')"
            :end-placeholder="$t('lang.结束日期')">
        </el-date-picker>
      </el-form-item>

      <el-form-item class="search-form-item" label="">
        <el-button size="mini" type="primary" icon="el-icon-search" @click.stop="handleSearch">{{ $t('lang.搜索') }}</el-button>
        <el-button size="mini" type="primary" @click="handleReset">{{ $t('lang.重置') }}</el-button>
      </el-form-item>

    </template>


    <template slot="table">
      <el-table :data="tableData" @selection-change="handleSelectionChange">

        <el-table-column type="selection" width="50"></el-table-column>

        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column prop="recipeNumber" :label="$t('lang.食谱编号')"></el-table-column>
        <el-table-column prop="recipeCategoryName" :label="$t('lang.分类')"></el-table-column>
        <el-table-column prop="recipeName" :label="$t('lang.食谱名称')"></el-table-column>
        <el-table-column prop="score" :label="$t('lang.评分')"></el-table-column>
        <el-table-column prop="content" :label="$t('lang.评价')"></el-table-column>
        <el-table-column prop="userNumber" :label="$t('lang.用户编号')"></el-table-column>
        <el-table-column prop="evaluationTimeStr" :label="$t('lang.评价时间')"></el-table-column>

        <el-table-column fixed="right" :label="$t('lang.操作')" width="100">
          <template slot-scope="scope">
            <el-button size="mini" plain type="danger" @click="handleDelete(scope.row)">{{ $t('lang.删除') }}</el-button>
          </template>
        </el-table-column>


      </el-table>

    </template>


  </fb-list-body>
</template>

<script>
export default {
  name: "UserEvaluationList",
  components: {},
  props: {
    timestamp: {
      type: Number,
      default: function () {
        return new Date().getTime()
      }
    },
  },
  data() {
    return {
      api: {
        list: this.$api.recipeUserEvaluation.list,
        delete: this.$api.recipeUserEvaluation.delete,
        batchDelete: this.$api.recipeUserEvaluation.batchDelete,
      },
      searchForm: {
        startTime: '',
        endTime: ''
      },
      tableData: [],
      selection: [],
      pager: {
        pageSize: 10,
        pageIndex: 1,
        itemCount: 0
      },
      time: [],
    }
  },
  computed: {
    searchParams() {
      return Object.assign({}, this.$route.query, this.searchForm, this.pager);
    }
  },
  watch: {
    time: {
      handler(val) {
        const vm = this;
        if (val.length) {
          vm.searchForm['startTime'] = val[0];
          vm.searchForm['endTime'] = val[1];
        }
      },
      immediate: true,
      deep: true,
    },
    timestamp() {
      this.handleGetData();
    },
    "pager.pageIndex": {
      handler() {
        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleGetData();

      },
      deep: true,
      immediate: true
    },
    "pager.pageSize": {
      handler() {

        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleGetData();

      },
      deep: true
    }

  },
  methods: {
    handleSearch() {
      this.pager.pageIndex = 1;
      this.pager.pageSize = 10;
      this.pager.itemCount = 0;
      this.handleGetData();
    },
    handleReset() {
      this.time = ''
      if(Object.keys(this.searchForm).length) {
        this.searchForm = {};
        this.searchForm = {
          startTime: '',
          endTime: ''
        }
        this.pager.pageIndex = 1;
        this.pager.pageSize = 10;
        this.pager.itemCount = 0;
        this.handleGetData();
      }
    },
    handleEdit(e) {

      if (e && e.code) {
        this.$router.push({
          path: 'edit',
          query: {
            code: e.code
          }
        });
        return;
      }

      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: this.$t('lang.未选择记录')
        });
        return;
      }

      if (this.selection.length > 1) {
        this.$message({
          type: 'warning',
          message: this.$t('lang.一次只能编辑一条数据')
        });
        return;
      }

      this.$router.push({
        path: 'edit',
        query: {
          code: this.selection[0].code
        }
      });
    },
    handleDelete(row) {


      let vm = this;

      vm.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'warning'
      }).then(() => {

        vm.$http.post(vm.api.delete, vm.$qs.stringify({
          code: row.code
        })).then((resp) => {
          if (resp.data.status === 200) {
            vm.$message({
              type: 'success',
              message: resp.data.desc
            });
            vm.handleGetData();
          } else {
            vm.$message({
              type: 'error',
              message: resp.data.desc
            });

          }
        })


      }).catch(() => {
        // this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        // });
      });

    },
    handleBatchDelete() {


      let vm = this;

      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: vm.$t('lang.未选择记录')
        });
        return;
      }


      let codes = [];

      this.selection.forEach((e) => {
        codes.push(e.code);
      });


      this.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'warning'
      }).then(() => {

        vm.$http.post(this.api.batchDelete, codes).then((resp) => {
          if (resp.data.status === 200) {
            vm.$message({
              type: 'success',
              message: resp.data.desc
            });
            vm.handleGetData();
          } else {
            vm.$message({
              type: 'error',
              message: resp.data.desc
            });

          }
        })


      }).catch(() => {
        // this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        // });
      });


    },
    handleSelectionChange(selection) {
      console.log(selection);
      this.selection = selection;
    },
    handlePagerSizeChange(e) {
      this.pager.pageSize = e;
    },
    handlePagerIndexChange(e) {
      this.pager.pageIndex = e;
    },
    handleGetData() {
      let vm = this;
      this.$http.post(this.api.list, this.$qs.stringify(this.searchParams)).then((resp) => {


        for (let key in resp.data.data) {
          if (resp.data.data[key] instanceof Array) {
            vm.tableData = resp.data.data[key];
          }
        }

        //处理分页
        vm.pager.pageIndex = resp.data.data.pager.pageIndex;
        vm.pager.pageSize = resp.data.data.pager.pageSize;
        vm.pager.itemCount = resp.data.data.pager.itemCount;

      })
    }
  },
  created() {

    for (let key in this.searchForm) {
      if (this.$route.query[key]) {
        this.searchForm[key] = this.$route.query[key];
      }
    }
  }
}
</script>

<style scoped>

</style>
